/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseLMSCapabilitiesParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['lms', codecString],
    ['setDeadline', codecBoolean, 'set_deadline'],
    ['setLockDate', codecBoolean, 'set_lock_date'],
    ['setState', codecBoolean, 'set_state'],
    ['setAvailableAt', codecBoolean, 'set_available_at'],
    ['setName', codecBoolean, 'set_name'],
    ['setMaxAttempts', codecBoolean, 'set_max_attempts'],
    [
        'cookiePostMessage',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'cookie_post_message',
    ],
    [
        'supportedCustomReplacementGroups',
        /* #__PURE__ */ codecArray(/* #__PURE__ */ codecArray(codecString)),
        'supported_custom_replacement_groups',
    ],
    ['useIdInUrls', codecBoolean, 'use_id_in_urls'],
    ['actualDeepLinkingRequired', codecBoolean, 'actual_deep_linking_required'],
    ['authAudienceRequired', codecBoolean, 'auth_audience_required'],
]));
export class BaseLMSCapabilities extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseLMSCapabilitiesParser.decode(input).map(res => new BaseLMSCapabilities(res));
    }
    static unsafeDecode(input) {
        return BaseLMSCapabilities.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseLMSCapabilitiesParser.encode(data);
    }
    static schema() {
        return BaseLMSCapabilitiesParser.schema();
    }
}
